import React from 'react'
import '../TermsOfUse.css';

function Cancellation() {
    return (
        <div className="terms-of-use dflex jc-center">
            <div className="w74">
                <h4>
                    Order Cancellation
                    We understand that sometimes plans may change and orders may need to be canceled. On our part, we will try to accommodate your requests as best as we can.

                    Are there any penalties for canceling orders?

                    Cancellations need to be made as soon as possible. If they are made more than 48 hours before the requested delivery date, there is a 50% cancellation fee of the total purchase price.

                    Are there any penalties for canceling my order scheduled for tomorrow?

                    If the cancellation is made less than 48 hours before the requested delivery date, the full purchase amount will will forfeited.

                    Can I cancel my cake order?

                    No. There is strict no cancellation or refund policy for all cakes after the order has been confirmed. In the event that a cancellation is needed, the order will still be chargeable at the full price.

                    How do I submit a request to cancel my order?

                    Please email your cancellation request with your order number to us at custsvc@FarEastFlora.com or contact us directly at (65) 6251 2323. 
                    <br/>
                    <br/>
                    Order Cancellation
                    We understand that sometimes plans may change and orders may need to be canceled. On our part, we will try to accommodate your requests as best as we can.

                    Are there any penalties for canceling orders?

                    Cancellations need to be made as soon as possible. If they are made more than 48 hours before the requested delivery date, there is a 50% cancellation fee of the total purchase price.

                    Are there any penalties for canceling my order scheduled for tomorrow?

                    If the cancellation is made less than 48 hours before the requested delivery date, the full purchase amount will will forfeited.

                    Can I cancel my cake order?

                    No. There is strict no cancellation or refund policy for all cakes after the order has been confirmed. In the event that a cancellation is needed, the order will still be chargeable at the full price.

                    How do I submit a request to cancel my order?

                    Please email your cancellation request with your order number to us at custsvc@FarEastFlora.com or contact us directly at (65) 6251 2323. 
                    <br/>
                    <br/>

                    Order Cancellation
                    We understand that sometimes plans may change and orders may need to be canceled. On our part, we will try to accommodate your requests as best as we can.

                    Are there any penalties for canceling orders?

                    Cancellations need to be made as soon as possible. If they are made more than 48 hours before the requested delivery date, there is a 50% cancellation fee of the total purchase price.

                    Are there any penalties for canceling my order scheduled for tomorrow?

                    If the cancellation is made less than 48 hours before the requested delivery date, the full purchase amount will will forfeited.

                    Can I cancel my cake order?

                    No. There is strict no cancellation or refund policy for all cakes after the order has been confirmed. In the event that a cancellation is needed, the order will still be chargeable at the full price.

                    How do I submit a request to cancel my order?

                    Please email your cancellation request with your order number to us at custsvc@FarEastFlora.com or contact us directly at (65) 6251 2323. 
                </h4>
            </div>
        </div>
    )
}

export default Cancellation
